export const LOAD_FACILITY_KPI_INDICATORS_STARTED = "LOAD_FACILITY_KPI_INDICATORS_STARTED";
export const LOAD_FACILITY_KPI_INDICATORS_SUCCEEDED = "LOAD_FACILITY_KPI_INDICATORS_SUCCEEDED";
export const LOAD_FACILITY_KPI_INDICATORS_FAILED = "LOAD_FACILITY_KPI_INDICATORS_FAILED";
